import { CmsApiFormBuilderBlockData } from 'modules/cms/api/types/blocks/CmsApiFormBuilderBlock';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpFormBuilderBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiFormBuilderBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      data={{
        ...data,
        image: data.bgImage,
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        text: data.headline,
        buttonText: data.submitButtonText,
        isEmailSignup: true,
      }}
      blockId={blockId}
    />
  );
}
